<template>
  <tg-layout ref="layout" :headerHeight="100">
    <template slot="header">
      <tg-amount-bar
        ref="amount"
        :columns="amountColumns"
        :row="amountData"
      ></tg-amount-bar>
    </template>
    <tg-table
      ref="table"
      :columns="columns"
      :proxy="proxy"
      align="center"
      :fit="true"
      showPagination
      showSummary
      :summary-method="parseSummary"
      @on-loaded="handleLoaded"
      @on-scroll="handleTableScroll"
    >
      <template slot="betId" slot-scope="scope">
        <tg-bet-id :row="scope.row"></tg-bet-id>
      </template>
      <template slot="userfullname" slot-scope="scope">
        <tg-user-full-name
          :row="scope.row"
          :column="scope.column"
        ></tg-user-full-name>
      </template>
      <template slot="cell" slot-scope="scope">
        <span
          :class="{
            'text-red': scope.value < 0,
            'text-green': scope.value > 0,
          }"
          >{{ scope.formated }}</span
        >
      </template>
    </tg-table>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgTable from "@/components/table/TgTable";
import TgAmountBar from "@/components/amount/TgAmountBar";
import TgUserFullName from "@/components/slot/TgUserFullName";
import TgBetId from "@/components/slot/TgBetId";

import { summary } from "@/utils/table";
import apis from "@/apis";
const api = apis.accounts.contribution;

export default {
  inheritAttrs: false,
  components: {
    TgLayout,
    TgTable,
    TgAmountBar,
    TgUserFullName,
    TgBetId,
  },
  provide() {
    return {
      container: this.$el,
    };
  },
  data() {
    return {
      columns: [],
      amountColumns: [],
      amountData: {},
      proxy: api.getData,
    };
  },
  props: {
    contribution: Object,
  },
  created() {
    api.getColumns().then((response) => {
      this.unassignColumns = response.data.unassignColumns;
      this.assignColumns = response.data.assignColumns;

      this.setColumns(this.contribution);
      this.$refs.table.init(this.contribution);
    });
  },
  mounted() {
    this.$refs.table.doLayout();
  },
  methods: {
    parseSummary({ data }) {
        return summary(this.columns, data, this.$t("component.table.summary"), this.contribution.status);
    },
    setColumns(contribution) {
      if (contribution.status == 0) {
        this.columns = this.unassignColumns;
      } else {
        this.columns = this.assignColumns;
      }
    },
    handleLoaded(response) {
      if (response.total && !("length" in response.total)) {
        this.amountData = response.total;
      }
    },
    handleTableScroll(e) {
      let target = e.target;
      this.$refs.amount.syncScrollX(
        target.scrollWidth - target.offsetWidth,
        target.scrollLeft
      );
    },
  },
  watch: {
    columns(val) {
      if (val) {
        let amountColumns = val
          .map((x) => {
            return { ...x };
          }).slice(0,-1);

        if (this.contribution.status == 0) {
          amountColumns = amountColumns.slice(1);
        }else{
          amountColumns = amountColumns.slice(2);
        }

        this.amountColumns = amountColumns;
      }
    },
    contribution(value) {
      this.setColumns(value);
      this.$refs.table.init(value);
    },
  },
};
</script>
